import { gql, useLazyQuery } from "@apollo/client";

const GET_COURSE_ENROLLMENT_STATUS = gql`
  query GetCourseEnrollmentStatus($userId: String!) {
    getCourseEnrollmentStatus(userId: $userId) {
      courseId
      status
      enrolledAt
      completedAt
      score
      certificateUrl
    }
  }
`;

export const useGetCourseEnrollmentStatus = () => {
  const [getCourseEnrollmentStatus, { loading, error, data }] = useLazyQuery(
    GET_COURSE_ENROLLMENT_STATUS
  );

  return {
    getCourseEnrollmentStatus,
    loading,
    error,
    data,
  };
};